import { useCallback, useState } from "react";

/**
 * Tracks a set of string ids (in-flight or failed) with immutable updates.
 *
 * Per-row / per-cell mutations that run concurrently each need to own their
 * pending/failed state independently; a shared boolean can't attribute status
 * to the right row. Updates copy the set so React sees a new reference.
 */
export function usePendingIdSet() {
  const [ids, setIds] = useState<ReadonlySet<string>>(new Set());

  const add = useCallback((id: string) => {
    setIds((prev) => new Set(prev).add(id));
  }, []);

  const remove = useCallback((id: string) => {
    setIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const reset = useCallback(() => setIds(new Set()), []);

  return { ids, add, remove, reset };
}
